import axios from 'axios'

const ApprovalService = {
  async get (params = {}) {
    return axios.get('rm/purchase-order/request-approvals', { params })
  },

  async histories (params = {}) {
    return axios.get('rm/reports/purchase-order/approval-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('rm/exports/purchase-order/request-approvals', { params })
  },

  async show (id) {
    return axios.get(`rm/purchase-order/request-approvals/${id}`)
  },

  async post (params = {}) {
    return axios.post('rm/purchase-order/request-approvals', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rm/purchase-order/request-approvals/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rm/purchase-order/request-approvals/${data.id}`, { data })
  }
}

export default ApprovalService
